import { Carousel, Image, Typography } from "antd";
import React from "react";
const { Title } = Typography;
const BodyComponent = (props) => {
  return (
    <>
      <Title level={2} style={{ textAlign: "center" }} className="mt-5 mb-3">
        Welcome To The MoGame
      </Title>
      <Carousel autoplay className="mt-3">
        <div>
          <Image
            src={`https://images.unsplash.com/photo-1542625202-258b9106f29e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80`}
            placeholder={
              <Image src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200" />
            }
          />
        </div>
        <div>
          <Image
            src={`https://images.unsplash.com/photo-1593024579758-6221e85efbe6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80`}
            placeholder={
              <Image src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200" />
            }
          />
        </div>
        <div>
          <Image
            src={`https://images.unsplash.com/photo-1596010848349-d16baf1e5868?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1345&q=80`}
            placeholder={
              <Image src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200" />
            }
          />
        </div>
        <div>
          <Image
            src={`https://images.unsplash.com/photo-1509564324749-471bd272e1ff?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80`}
            placeholder={
              <Image src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png?x-oss-process=image/blur,r_50,s_50/quality,q_1/resize,m_mfit,h_200,w_200" />
            }
          />
        </div>
      </Carousel>
    </>
  );
};

export default BodyComponent;
